import React from 'react';
import { Layout } from './Layout';
import { Table } from './Table';
import { ListingProps } from '../types';

export const Listing = <Data extends Record<string, any>, Context extends any = any>({
  onEmit,
  groups,
  columns,
  tableData,
  pagination,
  injectContext,
  loading = false,
  staticSettings,
  ...layoutProps
}: ListingProps<Data, Context>) => {
  const context = injectContext || ({ context: 'Empty' } as Context);

  return (
    <Layout<Context>
      context={context}
      table={
        <Table<Data, Context>
          groups={groups}
          onEmit={onEmit}
          columns={columns}
          loading={loading}
          context={context}
          tableData={tableData}
          pagination={pagination}
          staticSettings={staticSettings}
        />
      }
      {...layoutProps}
    />
  );
};
